var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function (resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator['throw'](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = this && this.__generator || function (thisArg, body) {
    var _ = {
            label: 0,
            sent: function () {
                if (t[0] & 1)
                    throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
    return g = {
        next: verb(0),
        'throw': verb(1),
        'return': verb(2)
    }, typeof Symbol === 'function' && (g[Symbol.iterator] = function () {
        return this;
    }), g;
    function verb(n) {
        return function (v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f)
            throw new TypeError('Generator is already executing.');
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y['return'] : op[0] ? y['throw'] || ((t = y['return']) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [
                        op[0] & 2,
                        t.value
                    ];
                switch (op[0]) {
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [0];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2])
                        _.ops.pop();
                    _.trys.pop();
                    continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __spreadArrays = this && this.__spreadArrays || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++)
        s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, {
    useEffect,
    useState
} from 'react';
import './index.less';
import { inject } from 'mobx-react';
import { observer } from 'mobx-react-lite';
import {
    Dragger,
    Button,
    Loader
} from 'oned';
import { ProgressBusiness } from '@business/newCreateRequest/common/progress';
import { stepReviewBusiness } from '@business/newCreateRequest/stepsItems/review';
import { combine } from 'fe-toolkit';
import {
    AmplitudeEventName,
    StepType
} from '@common/enums/base';
import { withRouter } from 'react-router-dom';
import classnames from 'classnames';
import moment from 'moment';
import {
    isMobile,
    isIH,
    getCurrentEnv,
    IsNotString,
    sendAmplitude_Default
} from '@common/utils';
import Disclaimer from './disclaimer';
import { AvailAbilityStep } from '@common/enums/availability';
import Cookies from 'js-cookie';
var StepsReview = inject(combine(stepReviewBusiness, ProgressBusiness))(observer(function (props) {
    var jump = props.jump, submit = props.submit, keyQuestionAnswers = props.keyQuestionAnswers, troubleShootingAnswers = props.troubleShootingAnswers, detail = props.detail, problemCaseCadeName = props.problemCaseCadeName, currentIconUrl = props.currentIconUrl, availabilityData = props.availabilityData, loading = props.loading, currentUser = props.currentUser, submitData = props.submitData, levelOneName = props.levelOneName, levelTwoName = props.levelTwoName, levelThreeName = props.levelThreeName, isAliasingView = props.isAliasingView, selectedAutoScheduleData = props.selectedAutoScheduleData, clearAllData = props.clearAllData, showDisclaimer = props.showDisclaimer, isRecallCheck = props.isRecallCheck, originWO = props.originWO, setAvailabilityParams = props.setAvailabilityParams, availabilityStep = props.availabilityStep;
    var _a = useState(false), loader = _a[0], setLoader = _a[1];
    var _b = useState(''), timeDom = _b[0], setTimeDom = _b[1];
    var _c = useState(false), isIh = _c[0], setIsIh = _c[1];
    var _d = useState(false), mobile = _d[0], setMobile = _d[1];
    var _e = useState(), attachment = _e[0], setAttachment = _e[1];
    var _f = useState(false), showAllAttach = _f[0], setShowAllAttach = _f[1];
    var maxLength = 2;
    useEffect(function () {
        setLoader(true);
        setIsIh(isIH());
        setMobile(isMobile);
        var t = setTimeout(function () {
            setLoader(false);
            clearTimeout(t);
        }, 500);
    }, []);
    useEffect(function () {
        if (mobile && isIh) {
            setAttachment(detail.attachmentList.filter(function (x, index) {
                return index < maxLength;
            }));
        } else {
            setAttachment(detail.attachmentList);
        }
    }, [mobile]);
    useEffect(function () {
        if (Object.keys(selectedAutoScheduleData).length > 0) {
            setTimeDom('<b>' + moment(selectedAutoScheduleData.scheduleStartTime).format('MMMM DD') + '</b> - ' + moment(selectedAutoScheduleData.scheduleStartTime).format('dddd'));
        } else {
            setTimeDom('');
        }
    }, [selectedAutoScheduleData]);
    var toggleAllAttachment = function () {
        showAllAttach ? setAttachment(detail.attachmentList.filter(function (x, index) {
            return index < 2;
        })) : setAttachment(detail.attachmentList);
        setShowAllAttach(!showAllAttach);
    };
    var onSubmit = function () {
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                case 0:
                    return [
                        4,
                        submit().then(function (data) {
                            sendAmplitude_Default(AmplitudeEventName.NewRSP_Step5to6, {
                                userId: currentUser.userId,
                                residentId: currentUser.residentId,
                                woId: submitData.id,
                                attachmentCount: detail.attachmentList.length,
                                clientId: Cookies.get('clientId'),
                                env: getCurrentEnv()
                            });
                            IsNotString(data) && clearAllData();
                            IsNotString(data) && jump(StepType.Submitted);
                        }).catch(function (error) {
                            sendAmplitude_Default(AmplitudeEventName.NewRSP_Create_WO_Failed, {
                                userId: currentUser.userId,
                                residentId: currentUser.residentId,
                                problemLevel1: levelOneName,
                                problemLevel2: levelTwoName,
                                problemLevel3: levelThreeName,
                                problemCaseCadeName: problemCaseCadeName,
                                clientId: Cookies.get('clientId'),
                                env: getCurrentEnv()
                            });
                            showNotification('Something was wrong, please try later!');
                        })
                    ];
                case 1:
                    _a.sent();
                    return [2];
                }
            });
        });
    };
    var showNotification = function (content) {
        window.notificationManager.show({
            title: 'Warning!',
            type: 'primary',
            position: 'top-right',
            content: content
        });
    };
    var jumpEvent = function (step) {
        if (step === StepType.Availability) {
            setAvailabilityParams('availabilityStep', AvailAbilityStep.AvailabilityIndex);
        }
        jump(step);
        sendAmplitude_Default(AmplitudeEventName.NewRSP_Edit, {
            userId: currentUser.userId,
            residentId: currentUser.residentId,
            step: StepType[step],
            clientId: Cookies.get('clientId'),
            env: getCurrentEnv()
        });
    };
    return React.createElement(React.Fragment, null, showDisclaimer && React.createElement(Disclaimer, null), !showDisclaimer && React.createElement(React.Fragment, null, loader ? React.createElement(Loader, { visible: loader }) : React.createElement(React.Fragment, null, React.createElement('div', { className: 'dsm-card rsp-step-details' }, React.createElement('div', { className: 'dsm-card-body cardBox' }, React.createElement('div', { className: 'd-flex align-items-center' }, currentIconUrl && React.createElement('img', {
        src: currentIconUrl,
        className: 'svc-icon mr-4'
    }), React.createElement('span', { className: classnames('detail-svc') }, isRecallCheck ? originWO.problems : problemCaseCadeName)), React.createElement('div', { className: 'm-t-40 ' }, React.createElement('div', { className: 'titleBox' }, React.createElement('span', { className: 'title' }, 'My description '), React.createElement('a', {
        href: 'javascript:void(0)',
        className: 'd-inline-flex align-items-center',
        onClick: function () {
            return jumpEvent(StepType.Detail);
        }
    }, React.createElement('span', { style: { fontSize: '16px' } }, ' Edit'), React.createElement('i', { className: 'sc-icon-pencil iconfont icon-edit text-primary f20 line-height-default' }))), React.createElement('div', { className: 'm-t-20 ' }, detail.additionalDetail)), React.createElement('div', { className: 'm-t-40 ' }, React.createElement('div', { className: 'titleBox' }, React.createElement('span', { className: 'title' }, 'Attachments '), React.createElement('a', {
        href: 'javascript:void(0)',
        className: 'd-inline-flex align-items-center',
        onClick: function () {
            return jumpEvent(StepType.Detail);
        }
    }, React.createElement('span', { style: { fontSize: '16px' } }, ' Edit'), React.createElement('i', { className: 'sc-icon-pencil iconfont icon-edit text-primary f20 line-height-default' }))), React.createElement('div', { className: ' mt-4' }, React.createElement(Dragger, {
        fileList: attachment,
        className: 'dragger',
        multiple: true,
        showRemove: false,
        onUpload: function (file) {
            throw new Error('Function not implemented.');
        }
    }), mobile && isIh && detail.attachmentList.length > maxLength && React.createElement('div', { className: 'pt-4 text-center cursor-pointer' }, React.createElement('span', {
        className: 'text-primary',
        onClick: toggleAllAttachment
    }, showAllAttach ? 'Collapse' : React.createElement(React.Fragment, null, 'See all attachments', React.createElement('span', { className: 'attachment-num ml-2' }, detail.attachmentList.length)))))), React.createElement('div', { className: 'm-t-40 ' }, React.createElement('div', { className: 'titleBox' }, React.createElement('span', { className: 'title' }, 'Questions '), React.createElement('a', {
        href: 'javascript:void(0)',
        className: 'd-inline-flex align-items-center',
        onClick: function () {
            return jumpEvent(StepType.Question);
        }
    }, React.createElement('span', { style: { fontSize: '16px' } }, ' Edit'), React.createElement('i', { className: 'sc-icon-pencil iconfont icon-edit text-primary f20 line-height-default' }))), __spreadArrays(keyQuestionAnswers, troubleShootingAnswers).map(function (item) {
        return React.createElement(React.Fragment, null, React.createElement('div', { className: 'm-t-20 html' }, item.questionName), item.answers && item.answers.length > 0 && React.createElement('div', { className: 'm-t-10 html reviewAnswer' }, item.answers.map(function (answer) {
            return React.createElement('div', null, answer);
        })), item.answer && React.createElement('div', { className: 'm-t-10 html reviewAnswer break-all' }, item.answer));
    })), React.createElement('div', { className: 'm-t-40 ' }, React.createElement('div', { className: 'titleBox' }, React.createElement('span', { className: 'title' }, availabilityStep === AvailAbilityStep.UnavailabilitySummary && 'Unavailable times ', availabilityStep === AvailAbilityStep.AvailabilitySummary && 'Available times ', availabilityStep !== AvailAbilityStep.UnavailabilitySummary && availabilityStep !== AvailAbilityStep.AvailabilitySummary && 'Availability '), React.createElement('a', {
        href: 'javascript:void(0)',
        className: 'd-inline-flex align-items-center',
        onClick: function () {
            return jumpEvent(StepType.Availability);
        }
    }, React.createElement('span', { style: { fontSize: '16px' } }, ' Edit'), React.createElement('i', { className: 'sc-icon-pencil iconfont icon-edit text-primary f20 line-height-default' }))), React.createElement('div', { className: 'mt-0  bottom availability-view row gutters-custom' }, availabilityData.map(function (ele, index) {
        return React.createElement(React.Fragment, null, React.createElement('div', { className: 'availability-view-item col-md-4 col-xs-12 mt-3' }, React.createElement('div', { className: 'btTitle' }, ele.formatDate), React.createElement('div', null, ele.list.map(function (e) {
            return React.createElement('div', { className: 'btItem mt-2' }, React.createElement('span', { className: 'btItem-l' }, e.timeQuantumId), React.createElement('span', { className: 'btItem-r' }, e.timeQuantumValue));
        }))));
    })), availabilityData.length === 0 && Object.keys(selectedAutoScheduleData).length === 0 && React.createElement('div', { className: 'm-t-t20 bottom' }, 'None selected.'), Object.keys(selectedAutoScheduleData).length > 0 && React.createElement('div', { className: 'autoSchedule-view row mt-0' }, React.createElement('div', { className: 'autoSchedule-view-item col-md-4 col-sm-12' }, React.createElement('div', {
        className: 'btTitle',
        dangerouslySetInnerHTML: { __html: timeDom }
    }), React.createElement('div', { className: 'm-t-20' }, React.createElement('div', { className: 'btItem cp active' }, selectedAutoScheduleData.timeQuantumValue))))))), React.createElement(Button, {
        type: 'primary',
        className: 'w-100 my-4 dsm-btn-primary dsm-btn',
        onClick: function () {
            return onSubmit();
        }
    }, 'Submit'))), React.createElement(Loader, {
        visible: loading,
        page: true
    }));
}));
export default withRouter(StepsReview);